<template>
  <div class="login-container">
    <div class="col-xs-12">
      <div class="login">

          <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

        <!-- Begin Client Logo -->
        <div class="logo"></div>

        <div class="header-bar text-center mcBG">
          <img src="static/img/i3v_icon_white.png"> <h1>uManage Mobile{{sandboxTitle}}</h1>
        </div>
       
        <div class="form-container">
          <h2 class="scText">Image Upload</h2>


          <p class="text-center">Tap or Click to take a picture or choose one from your files.</p>
           <dropzone 
          id="myVueDropzone"
          url="https://umanagemobile.s3.amazonaws.com"
          v-on:vdropzone-success="showSuccess"
          v-bind:preview-template="template">
<input type="hidden" name="key" value="${filename}" />
<input type="hidden" name="acl" value="public-read" />
<input type="hidden" name="X-Amz-Credential" value="AKIAJUCRBPCVPXUQRPMA/20171004/us-east-2/s3/aws4_request" />
<input type="hidden" name="X-Amz-Algorithm" value="AWS4-HMAC-SHA256" />
<input type="hidden" name="X-Amz-Date" value="20171004T165244Z" />
<input type="hidden" name="Policy" value="eyJleHBpcmF0aW9uIjoiMjAxNy0xMC0xMFQwOjUyOjQ0WiIsImNvbmRpdGlvbnMiOlt7ImFjbCI6InB1YmxpYy1yZWFkIn0seyJidWNrZXQiOiJ1bWFuYWdlbW9iaWxlIn0seyJzdWNjZXNzX2FjdGlvbl9yZWRpcmVjdCI6Imh0dHA6XC9cL2xvY2FsaG9zdFwvcmVBU1wvQVdTXC8ifSxbInN0YXJ0cy13aXRoIiwiJGtleSIsIiJdLFsiY29udGVudC1sZW5ndGgtcmFuZ2UiLCIxIiwiMjA5NzE1MiJdLHsieC1hbXotY3JlZGVudGlhbCI6IkFLSUFKVUNSQlBDVlBYVVFSUE1BXC8yMDE3MTAwNFwvdXMtZWFzdC0yXC9zM1wvYXdzNF9yZXF1ZXN0In0seyJ4LWFtei1hbGdvcml0aG0iOiJBV1M0LUhNQUMtU0hBMjU2In0seyJYLWFtei1kYXRlIjoiMjAxNzEwMDRUMTY1MjQ0WiJ9XX0=" />
<input type="hidden" name="X-Amz-Signature" value="74ba2a5dfe80cf5e73c7e665f309943dc8e37426f453435d3cf71c8033531cac" />
<input type="hidden" name="success_action_redirect" value="http://localhost/reAS/AWS/" /> 

        </dropzone>
  
    </div>

        </div>


     
     
      <pre v-show="false">
        {{ $data }}
      </pre>

    </div>
  </div>
</template>

<script>




import Store from '../store'
import User from '../services/user'
import Dropzone from 'vue2-dropzone'
let request = require('superagent')
let _ = require('highland')

export default {

  name: 'Login',
  components: {
    Dropzone
  },
  created() {
  },
  methods: {

    'showSuccess': function (file) {
        console.log('A file was successfully uploaded')
      },
      'template':function() {
          return `
                  <div class="dz-preview dz-file-preview">
                      <div class="dz-image" style="width: 200px;height: 200px">
                          <img data-dz-thumbnail /></div>
                      <div class="dz-details">
                        <div class="dz-size"><span data-dz-size></span></div>
                        <div class="dz-filename"><span data-dz-name></span></div>
                      </div>
                      <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                      <div class="dz-error-message"><span data-dz-errormessage></span></div>
                      <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                      <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                  </div>
              `;
      }
  },
  data () {
    return {
      user: '',
      pass: '',
      loginError: false,
      logout: false,
      loginLoading: false,
      sandboxTitle: (process.env.NODE_ENV === 'production') ? "" : " : Test"
    }
  }
}
</script>

<style scoped>
.login-container {
    margin: 0 auto;
    max-width: 780px;
}

.login-container .col-xs-12 {
    padding-left: 0;
    padding-right: 0;
}

.login {
    padding-top: 20px;
}

.login img {
    max-width: 180px; 
}

.header-bar {
    margin-top: 15px;
    padding: 10px 0;
}

.header-bar img {
    display: inline-block;
    max-width: 50px;
}

.header-bar h1 {
    color: #fff;
    display: inline-block;
    font-size: 22px;
    margin: 0 0 0 5px;
    padding: 0;
}

.form-container {
    background: #f8f8f8;
    padding: 15px;
    text-align: center;
}

.form-container h2 {
    font-family: 'ralewayblack';
    font-size: 24px;
    margin: 10px 0 20px;
    padding: 0;
    text-transform: uppercase;
}

.form-container .form-group {
    margin-bottom: 30px;
}

.form-container .form-control {
    background: #eaedf0;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;
    border: 0;
    display: inline-block;
    font-size: 16px;
    font-family: 'open_sanssemibold';
    height: 55px;
    max-width: 400px;
    text-align: center;
}

.form-container .validation-error {
    color: #cc0000;
    display: block;
    font-size: 11px;
    font-family: 'open_sanssemibold';
    margin-top: 3px;
}

.form-container .btn {
    border: 0;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;
    color: #fff;
    display: inline-block;
    font-family: 'ralewayblack';
    font-size: 20px;
    height: 55px;
    line-height: 20px;
    max-width: 360px;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    transition: all 0.5s ease;
    text-transform: uppercase;
    width: 100%;
}

.form-container .btn i {
    margin-left: 5px;
}

.error-message {
    background: url(../../static/img/error-stripes.jpg);
    border: 2px solid #cc0000;
    color: #333;
    font-family: 'open_sanssemibold';
    font-size: 16px;
    margin-bottom: 25px;
    padding: 15px;
}

@media only screen and (min-width : 768px) {
    .header-bar {
        -webkit-border-top-left-radius: 8px;
        -webkit-border-top-right-radius: 8px;
        -moz-border-radius-topleft: 8px;
        -moz-border-radius-topright: 8px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }

    .form-container {
        -webkit-border-bottom-right-radius: 8px;
        -webkit-border-bottom-left-radius: 8px;
        -moz-border-radius-bottomright: 8px;
        -moz-border-radius-bottomleft: 8px;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
    } 
}

    .vue-dropzone {
        border: 2px solid #000000;
        font-family: 'Arial', sans-serif;
        letter-spacing: 0.2px;
        color: #777;
        transition: background-color .2s linear;
        &:hover {
            background-color: #F6F6F6;
        }
        i {
            color: #CCC;
        }
        .dz-preview {
            .dz-image {
                border-radius: 1;
                &:hover {
                    img {
                        transform: none;
                        -webkit-filter: none;
                    }
                }
            }
            .dz-details {
                bottom: 0;
                top: 0;
                color: white;
                background-color: rgba(33, 150, 243, 0.8);
                transition: opacity .2s linear;
                text-align: left;
                .dz-filename span, .dz-size span {
                    background-color: transparent;
                }
                .dz-filename:not(:hover) span {
                    border: none;
                }
                .dz-filename:hover span {
                    background-color: transparent;
                    border: none;
                }
            }
            .dz-progress .dz-upload {
                background: #cccccc;
            }
            .dz-remove {
                position: absolute;
                z-index: 30;
                color: white;
                margin-left: 15px;
                padding: 10px;
                top: inherit;
                bottom: 15px;
                border: 2px white solid;
                text-decoration: none;
                text-transform: uppercase;
                font-size: 0.8rem;
                font-weight: 800;
                letter-spacing: 1.1px;
                opacity: 0;
            }
            &:hover {
                .dz-remove {
                    opacity: 1;
                }
            }
            .dz-success-mark, .dz-error-mark {
                margin-left: auto !important;
                margin-top: auto !important;
                width: 100% !important;
                top: 35% !important;
                left: 0;
                i {
                    color: white !important;
                    font-size: 5rem !important;
                }
            }
        }
    }

  

</style>



// WEBPACK FOOTER //
// Dev.vue?d8e61198